import { useCallback, useEffect, useState } from 'react';

import localStorageEx from 'bundles/common/utils/localStorageEx';

/**
 * React hook to get and set data from local storage
 * @param key Key to store at.
 * @param defaultValue Initial value
 */
export function useLocalStorage<T>(key: string, defaultValue: T) {
  const [value, setValue] = useState(defaultValue);
  useEffect(() => {
    if (!localStorageEx.isAvailable()) return;
    const savedState = localStorageEx.getItem(key, JSON.parse, defaultValue);
    setValue(savedState);
  }, [defaultValue, key]);

  const updateValue = useCallback<(newValue: T) => void>(
    (newValue) => {
      setValue(newValue);
      if (!localStorageEx.isAvailable()) return;
      localStorageEx.setItem(key, newValue, JSON.stringify);
    },
    [key]
  );

  return [value, updateValue] as const;
}
